import React, { useEffect, useState } from "react";
import SlantSection from "../components/Slant/Slant";
import { Link, graphql, useStaticQuery } from "gatsby";
import HeroSection from "../components/Sections/HeroSection";
import { Flex } from "theme-ui";
import Button from "../components/Buttons/Button";
import GetUpToSection from "../components/Sections/GetUpToSection";
import TrustPilotBottomBlock from "../blocks/Blocks/TrustPilotBottomBlock";
import Layout from "../layouts/layout";
import TrustPilotBlock from "../blocks/Blocks/TrustPilotBlock";

interface Props {}

const locationPage = ({ pageContext, data }: any) => {
  const {
    address1,
    zipcode,
    hours,
    managerName,
    emailAddress,
    city,
    phoneNumber,
    stateName,
    maxLoanAmount,
    branchName,
    branchId,
  } = pageContext;
  const { gatsbyImageData } = data.logo.childImageSharp;
  const addPlus = (string: string) => string.replace(/ /g, "+");
  const googleMapsLink = `https://www.google.com/maps/embed/v1/place?q=${addPlus(
    address1
  )},${addPlus(
    city
  )},${stateName}+${zipcode}&key=AIzaSyDBrBUE_X8ezq91E-yeh0i4VWhbO1u6o_I`;
  const sources = [
    data.mobileHero.childImageSharp.fluid,
    {
      ...data.hero.childImageSharp.fluid,
      media: `(min-width: 1019px)`,
    },
  ];
  return (
    <Layout>
      <HeroSection
        {...data.allDataJson.edges[0].node.LocationPage.HeroBlock}
        backgroundImage={sources}
        contentWidth={"50%"}
        backgroundImageStyle={{
          height: [1050, null, 1000, 700, null, 900],
        }}
        heading={{
          text: `Apply now for a loan in ${city}, ${stateName}`,
          color: "darkBlue",
        }}
        subHeader={{
          text: `Fast, easy personal, installment loans up to $${parseInt(
            maxLoanAmount
          ).toLocaleString()}<sup>*</sup>`,
          color: "black",
        }}
        logo={gatsbyImageData}
      />
      <SlantSection
        variant="full"
        sx={{
          justifyContent: "center",
        }}
      >
        <Flex
          sx={{
            flexWrap: "wrap",
            justifyContent: "space-around",
            alignItems: "center",
            maxWidth: 1920,
            px: [3, null, null, 5],
            pb: 5,
          }}
        >
          <div
            sx={{
              width: ["100%", null, null, "50%"],
              px: 2,
            }}
          >
            <h2
              sx={{
                color: "darkBlue",
              }}
            >
              {branchName} In {city}, {stateName}
            </h2>
            <p>
              We are now a cash-free branch. Don’t worry. We have several easy
              ways to pay. Click{" "}
              <Link
                to="/payment-options"
                sx={{ fontSize: [18, null, null, 22] }}
              >
                here
              </Link>{" "}
              to learn about our payment options.
            </p>
            <div
              sx={{
                div: {
                  my: 3,
                },
                p: {
                  m: 0,
                  width: ["50%", null, null, "70%"],
                  lineHeight: "45px",
                },
                strong: {
                  m: 0,
                  width: ["50%", null, "30%"],
                  fontSize: 18,
                  lineHeight: "45px",
                },
              }}
            >
              <Flex>
                <strong>Address:</strong>
                <p>{address1}</p>
              </Flex>
              <Flex>
                <strong>Phone:</strong>
                <a
                  sx={{
                    fontSize: [18, null, null, 22],
                    lineHeight: "45px",
                  }}
                  href={`tel:${phoneNumber}`}
                >
                  {phoneNumber
                    .replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, "($2) $3-$4")
                    .replace("+", "")}
                </a>
              </Flex>
              <Flex>
                <strong>Office Hours:</strong>
                <p>{hours}</p>
              </Flex>
              <Flex>
                <strong>Branch ID#:</strong>
                <p>{branchId}</p>
              </Flex>
              {managerName !== "Janell Costello" && (
                <Flex>
                  <strong>Manager:</strong>
                  <p>{managerName}</p>
                </Flex>
              )}
            </div>
            <Flex
              sx={{
                flexWrap: "wrap",
                pt: 3,
                pb: 3,
                justifyContent: ["center", null, null, "flex-start"],
              }}
            >
              {/* <Button
                text="Apply Now"
                variant="blue"
                href="https://apply.heightsfinance.com/?brand=all"
                sx={{
                  mx: [3, null, null, 0],
                }}
              /> */}
              <Button
                text="Call Now"
                variant="blue"
                href={`tel:1${phoneNumber.replace(/[^0-9]/g, "")}`}
                sx={{
                  mx: [3, null, null, 0],
                  left: -20,
                }}
              />
            </Flex>
          </div>
          <div
            sx={{
              width: ["100%", null, null, "40%"],
            }}
          >
            <iframe src={googleMapsLink} width={"100%"} height={500} />
          </div>
        </Flex>
      </SlantSection>
      <GetUpToSection
        backgroundColor="#EAF0F4"
        heading={{
          text: "Get the money you need today quickly, easily and with the respect you deserve.",
          color: "black",
        }}
        subText={{
          text: `Get up to $${parseInt(
            maxLoanAmount
          ).toLocaleString()} today quickly, easily and with the respect you deserve. At ${branchName}, you are much more than just a credit score. We’ll work with you to create a loan that fits your needs, and get your money to you as quickly as possible. And we’ll treat you with the same respect we’d want for our own friends and family members.`,
          color: "black",
        }}
      />
      <TrustPilotBlock />
    </Layout>
  );
};

export const LocationsPageQuery = graphql`
  query LocationsQuery($branchName: String) {
    hero: file(relativePath: { eq: "store-location/1920x800.jpg" }) {
      childImageSharp {
        fluid(quality: 100, maxWidth: 1920) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    mobileHero: file(relativePath: { eq: "store-location/700x1000.jpg" }) {
      childImageSharp {
        fluid(quality: 100, maxWidth: 700) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    logo: file(name: { eq: $branchName }) {
      childImageSharp {
        gatsbyImageData(width: 300, placeholder: NONE, formats: [WEBP, AVIF])
      }
    }
    allDataJson {
      edges {
        node {
          LocationPage {
            HeroBlock {
              button1 {
                text
                to
                variant
              }
              button2 {
                text
                to
                variant
              }
            }
          }
        }
      }
    }
  }
`;

export default locationPage;
